export default {"src":"/_next/static/media/Share.33baf7fc.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};